import { Component, OnInit } from '@angular/core';
import { VesselCalculationInventoryService } from 'src/app/services/danish-shipping-services/vessel-calculation-inventory.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-vessel-subgroup-list',
  templateUrl: './vessel-subgroup-list.component.html',
  styleUrls: ['./vessel-subgroup-list.component.css']
})
export class VesselSubgroupListComponent implements OnInit {
vesselSubgroups: any[] = [];
  filteredVesselSubgroups: any[] = [];
  searchTerm: string = '';

  constructor(private vesselService: VesselCalculationInventoryService, private toastr: ToastrService) {}

  ngOnInit(): void {
    this.loadVesselSubgroups();
  }
deleteSubgroupGroup(subgroups: any[]): void {
  if (!subgroups || subgroups.length === 0) {
    this.toastr.warning('No subgroups to delete.');
    return;
  }

  if (confirm('Are you sure you want to delete all subgroups for this vessel type?')) {
    let deleteCount = 0;

    subgroups.forEach((subgroup, index) => {
      this.vesselService.deleteVesselSubgroup(subgroup.id).subscribe({
        next: () => {
          deleteCount++;
          if (deleteCount === subgroups.length) {
            this.toastr.success('All subgroups deleted successfully.');
            this.loadVesselSubgroups(); // Refresh after all deletions
          }
        },
        error: () => {
          this.toastr.error(`Failed to delete subgroup with ID ${subgroup.id}.`);
        }
      });
    });
  }
}

  loadVesselSubgroups(): void {
    this.vesselService.getAllVesselSubgroups().subscribe(
      (response: any) => {
        this.vesselSubgroups = response;
        this.filteredVesselSubgroups = [...response];
      },
      error => {
        console.error('Error fetching vessel subgroups:', error);
        this.toastr.error('Failed to load vessel subgroups.');
      }
    );
  }

  filterOptions(): void {
    const term = this.searchTerm.toLowerCase();
    this.filteredVesselSubgroups = this.vesselSubgroups.filter(v =>
      v.vesselType.toLowerCase().includes(term) || v.subType.toLowerCase().includes(term)
    );
  }
  deleteVesselSubgroup(id: number): void {
  if (confirm('Are you sure you want to delete this vessel subgroup?')) {
    this.vesselService.deleteVesselSubgroup(id).subscribe({
      next: () => {
        this.toastr.success('Vessel subgroup deleted successfully.');
        this.loadVesselSubgroups();
      },
      error: () => {
        this.toastr.error('Failed to delete vessel subgroup.');
      }
    });
  }
}

}